function hexToRgba(hexColor: string, alpha: number) {
  const normalizedHex = hexColor.replace('#', '');
  const red = parseInt(normalizedHex.slice(0, 2), 16);
  const green = parseInt(normalizedHex.slice(2, 4), 16);
  const blue = parseInt(normalizedHex.slice(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

export const CARTOGRAPHER_VIEWPORT_SKY_HEX_COLOR = '#2188d8';
//export const CARTOGRAPHER_VIEWPORT_SKY_HEX_COLOR = '#42aad7';

export const CARTOGRAPHER_VIEWPORT_FLOOR_HEX_COLOR = '#a0a0a0';
export const CARTOGRAPHER_VIEWPORT_GRADIENT_STOPS = {
  skyHoldEnd: '48%',
  floorStart: '80%',
} as const;

export const CARTOGRAPHER_VIEWPORT_LOADING_OVERLAY_BACKGROUND = `linear-gradient(
  180deg,
  ${hexToRgba(CARTOGRAPHER_VIEWPORT_SKY_HEX_COLOR, 0.21)} 0%,
  ${hexToRgba(CARTOGRAPHER_VIEWPORT_SKY_HEX_COLOR, 0.21)} ${CARTOGRAPHER_VIEWPORT_GRADIENT_STOPS.skyHoldEnd},
  ${hexToRgba(CARTOGRAPHER_VIEWPORT_FLOOR_HEX_COLOR, 0.18)} ${CARTOGRAPHER_VIEWPORT_GRADIENT_STOPS.floorStart},
  ${hexToRgba(CARTOGRAPHER_VIEWPORT_FLOOR_HEX_COLOR, 0.18)} 100%
)`;
